module.exports = __webpack_public_path__ + "img/white_seniors.37adafb9.svg";